import { useEffect } from "react";
import { useNavigate, useParams } from "@tanstack/react-router";

/**
 * Redirect /{tenantSlug}/ to the personal Home hub, which is the default
 * landing for every role (always loaded, regardless of tenant activeModules).
 */
export function TenantIndexRedirect() {
  const navigate = useNavigate();
  const { tenantSlug } = useParams({ from: "/$tenantSlug" }) as {
    tenantSlug: string;
  };

  useEffect(() => {
    void navigate({ to: `/${tenantSlug}/home` });
  }, [navigate, tenantSlug]);

  return <p className="p-6 text-caption text-fg-muted">Reindirizzamento…</p>;
}
